import React, { useState } from 'react';
import style from '../content-list.module.scss';
import InfiniteScroll from "react-infinite-scroll-component";
import AddIcon from '../../../../../../../../assets/svg/solo-chat/circle-plus.svg';
import { Carousel } from './Carousel';
import { Carousel as TCarousel } from '../../types';
import { AddCarousel } from './AddCarousel';
import { usePermissions } from '../../../../hooks';

type Props = {
	scrollRef:any | null;
	hasMore:boolean;
	contents: (TCarousel & { id: string; updatedAt: string|null; createdAt: string })[];
	refetchContent: () => void;
	loadMore: () => void;
};

export function CarouselList(props: Props) {
	const {scrollRef, contents: carousels, hasMore, refetchContent, loadMore} = props;

	return (
		<div className={style.contentList}>
			<Header {...props} />
			<div className={style.selector}>
				<div>
					<p>Card Carousel</p>
				</div>
				<p>Updated At</p>
				<p>Created At</p>
			</div>
			<div id="infiniteScrollTarget" ref={scrollRef} style={{overflow: "auto", height: "calc(100vh - 200px)",padding:"0px 4px"}} className={style.textList}>
				{carousels.length>0?
					<InfiniteScroll
						dataLength={carousels.length}
						next={loadMore}
						hasMore={hasMore}
						scrollableTarget="infiniteScrollTarget"
						loader={<div className={style.loadingContainer}>Loading...</div>}>
						{carousels.map((el) => (
							<Carousel key={el.id} carousel={el} refetchContent={refetchContent} />
						))}
					</InfiniteScroll>
				:
					null
				}
			</div>
		</div>
	);
}

function Header(props: Props) {
	const [isOpen, setIsOpen] = useState(false);
	const canCreate = usePermissions('content.Create')
	return (
		<div className={style.header}>
			{ canCreate &&
				<button className={style.add} onClick={() => setIsOpen(true)}>
				<img src={AddIcon} alt="add" />
				<span>Add Card Carousel</span>
			</button>
			}
			{isOpen && (
				<AddCarousel
					isOpen={isOpen}
					close={() => setIsOpen(false)}
					refetchContent={props.refetchContent}
				/>
			)}
		</div>
	);
}
